import { Button } from "@mui/material";
import { paletteColors } from "../muiTheme";
import styled from "@emotion/styled";

const SecondaryButton = styled(Button)({
  "background": paletteColors.taupe.dark,
  "fontSize": "1rem",
  "textTransform": "capitalize",
  "&:hover": {
    background: paletteColors.gray.light,
    color: "black",
  },
  "height": "auto",
});

export default SecondaryButton;
